import React from 'react';
import './experience.css'




import NavbarHeader from '../Navbarheader/NavbarHeader';

import Experience from './Experience';
import Footer from '../Footer/Footer';




function ExperiencePage() {

  

 



  return (
    <div fluid style={{ height: 100 + "vh" }} className="scroll-container">


      <NavbarHeader />

     <Experience />
     <Footer />





    </div>
  );
}

export default ExperiencePage;
